export function parsePath(path) {
    return path.split('.');
}
//# sourceMappingURL=path.js.map